(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("blockly/core"));
	else if(typeof define === 'function' && define.amd)
		define(["blockly/core"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("blockly/core")) : factory(root["Blockly"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__573__) {
return 